import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { COMMON_PLACEHOLDER, ROLE_KEYS_MAP } from '@constants';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { RenderFormDomInterface, rendercomponents } from '@utils/formRender';
import { getCityItem, getItemByKey, valToString } from '@utils/tool';
import { initialFromValues } from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import { sectorMap, sectorValueMap } from '@views/pages/AnnouncementList/tool';
import { Col, Form, Row, Space } from 'antd';
import { useEffect } from 'react';
import { use_NOTICE_FORM_LIST } from './data';
import './index.scss';
import { useRecoilState } from 'recoil';
import { userInfo } from '@store';

interface Props {
  record: any; // 公告详情
  open: boolean;
  setOpen: (val: boolean) => void;
  handleOk?: (data?: any) => void;
  handleCancel?: (data?: any) => void;
  dicList: any;
  systemCity: SystemCityItemInterface[];
  formRef: any;
}

export const EditInfoModal = ({
  open,
  setOpen,
  dicList,
  handleOk,
  record,
  handleCancel,
  formRef,
  systemCity
}: Props) => {
  const form: any = formRef;
  const { sector, noticeType: noticeTypeOptionsList } = dicList;
  const [userInfos] = useRecoilState(userInfo);
  const isSales = userInfos.roleKeys === ROLE_KEYS_MAP.sales;
  const sectorTypeFromForm: string = Form.useWatch('sectorType', form);
  // 行业
  const industryKeyFromForm: string = Form.useWatch('industryKey', form);
  const NOTICE_FORM_LIST = use_NOTICE_FORM_LIST();
  // if (dicList?.data) {
  // }

  useEffect(() => {
    if (sectorTypeFromForm === sectorValueMap.AMS) {
      form.setFieldsValue({
        applicationDirectionKey: ''
      });
    }
  }, [industryKeyFromForm]);

  const initFn = () => {
    const formData = formatInitFormData({
      ...record
    });

    form.setFieldsValue({
      ...formData
    });

    const { industryKey, customerCompanyType, applicationDirectionKey } =
      formData;

    setTimeout(() => {
      form.setFieldsValue({
        industryKey,
        customerCompanyType,
        applicationDirectionKey
      });
    }, 500);
  };

  useEffect(() => {
    if (!open) {
      return;
    }

    initFn();
  }, [record, open]);

  // 格式化数据
  const formatInitFormData = (data: any) => {
    const {
      sectorType,
      customerCompanyType,
      customerCompanyTypeName,
      customerCompanySecondType,
      customerCompanySecondTypeName,
      industryKey,
      applicationDirectionKey,
      applicationDirectionName,
      applicationDirectionSecondKey,
      applicationDirectionSecondName,
      cityCode,
      cityName,
      provinceCode,
      provinceName,
      noticeType
    } = data;

    const provinceAndCity = [];
    if (provinceCode) {
      provinceAndCity.push(`${provinceCode}-${provinceName}`);
    }
    if (cityCode) {
      provinceAndCity.push(`${cityCode}-${cityName}`);
    }

    const newApplicationDirectionKey = [];
    if (applicationDirectionKey) {
      newApplicationDirectionKey.push(
        `${applicationDirectionKey}${COMMON_PLACEHOLDER}${applicationDirectionName}`
      );
    }
    if (applicationDirectionSecondKey) {
      newApplicationDirectionKey.push(
        `${applicationDirectionSecondKey}${COMMON_PLACEHOLDER}${applicationDirectionSecondName}`
      );
    }

    const newCustomerCompanyTypeKey = [];

    if (customerCompanyType) {
      newCustomerCompanyTypeKey.push(
        `${customerCompanyType}${COMMON_PLACEHOLDER}${customerCompanyTypeName}`
      );
    }
    if (customerCompanySecondType) {
      newCustomerCompanyTypeKey.push(
        `${customerCompanySecondType}${COMMON_PLACEHOLDER}${customerCompanySecondTypeName}`
      );
    }

    return {
      sectorType: valToString(sectorType),
      customerCompanyType: newCustomerCompanyTypeKey,
      industryKey: valToString(industryKey),
      applicationDirectionKey: newApplicationDirectionKey,
      provinceAndCity,
      noticeType
    };
  };

  const createProjectHandle = async () => {
    try {
      const values = await form.validateFields();

      const {
        customerCompanyType,
        industryKey,
        applicationDirectionKey,
        sectorType,
        provinceAndCity,
        noticeType
      } = values;

      // 应用方向
      const applicationItem = getCityItem(
        applicationDirectionKey[0],
        COMMON_PLACEHOLDER
      );
      const applicationSecondItem = getCityItem(
        applicationDirectionKey[1],
        COMMON_PLACEHOLDER
      );
      // 客户单位类型
      const customerCompanyTypeItem = getCityItem(
        customerCompanyType[0],
        COMMON_PLACEHOLDER
      );
      const customerCompanyTypeSecondItem = getCityItem(
        customerCompanyType[1],
        COMMON_PLACEHOLDER
      );
      const sectorOptionsItem = getSectorRelatedOption();

      const provinceItem = getCityItem(provinceAndCity[0]);
      const cityCodeItem = getCityItem(provinceAndCity[1]);

      const params = {
        // ...otherNoticeValues,
        sectorType,
        sectorTypeValue: getItemByKey(sector, 'dictKey', sectorType)?.dictValue,
        industryKey,
        industryName: getItemByKey(
          sectorOptionsItem?.industry,
          'dictKey',
          industryKey
        )?.dictValue,
        noticeType,
        noticeTypeValue: getItemByKey(
          noticeTypeOptionsList,
          'dictKey',
          noticeType
        )?.dictValue,
        applicationDirectionKey: applicationItem?.code ?? 0,
        applicationDirectionName: applicationItem?.label ?? '',
        applicationDirectionSecondKey: applicationSecondItem?.code ?? 0,
        applicationDirectionSecondName: applicationSecondItem?.label ?? '',
        customerCompanyType: customerCompanyTypeItem?.code ?? 0,
        customerCompanyTypeName: customerCompanyTypeItem?.label ?? '',
        customerCompanySecondType: customerCompanyTypeSecondItem?.code ?? 0,
        customerCompanySecondTypeName:
          customerCompanyTypeSecondItem?.label ?? '',
        provinceCode: provinceItem?.code || '',
        provinceName: provinceItem?.label || '',
        cityCode: cityCodeItem?.code || '',
        cityName: cityCodeItem?.label || ''
      };

      handleProjectFn({
        ...params
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  // 项目回调
  const handleProjectFn = async (data: any) => {
    handleOk?.(data);
  };

  useEffect(() => {
    // 为了限制弹窗出来后因为数据变化造成的Sector相关联动多个表单数据丢失问题
    // const formData = formatInitFormData({
    //   ...record
    // });

    // const { sectorType } = formData;

    // if (sectorType === sectorTypeFromForm) {
    //   return;
    // }

    form.setFieldsValue({
      customerCompanyType: '',
      industryKey: '',
      applicationDirectionKey: ''
    });
  }, [sectorTypeFromForm]);

  const onFormChange = () => {};

  const getSectorRelatedOption = () => {
    const sectorDictItem = dicList.sectorDict?.[sectorMap[sectorTypeFromForm]];
    return sectorDictItem || {};
  };

  // 下拉
  const renderSelectOptions = (data: any) => {
    const { name, optionsListKey } = data;
    let sectorOptionsItem = null;
    if (sectorTypeFromForm) {
      sectorOptionsItem = getSectorRelatedOption();
    }
    // Sector下拉联动
    if (name === 'customerCompanyType' && sectorTypeFromForm) {
      const { customerCompanyType } = sectorOptionsItem;
      return customerCompanyType;
    } else if (name === 'industryKey' && sectorTypeFromForm) {
      const { industry } = sectorOptionsItem;
      return industry;
    } else if (name === 'applicationDirectionKey' && sectorTypeFromForm) {
      const { applicationDirection, industry } = sectorOptionsItem;
      // AMS行业和应用方向联动逻辑
      if (sectorTypeFromForm === sectorValueMap.AMS) {
        const item = industry.find(
          (v: any) => v.dictKey === industryKeyFromForm
        );
        return item?.children || [];
      } else {
        return applicationDirection || [];
      }
    } else if (name === 'provinceAndCity') {
      return systemCity;
    }
    return dicList[optionsListKey] ?? [];
  };

  const renderForm = (data: any[] = [], formRef = form) => {
    // 蔡司销售根据直销和经销区分sector下拉数据
    if (isSales) {
      dicList.sector =
        dicList.sector?.filter(
          (v: any) => v.dictRemark === record?.dataFlag?.toString()
        ) || [];
    }
    const obj: RenderFormDomInterface = {
      optionCallback: renderSelectOptions
    };
    return (
      <Form
        form={formRef}
        layout="vertical"
        onValuesChange={onFormChange}
        initialValues={initialFromValues}
        preserve={false}
      >
        <Row gutter={[24, 0]} justify={'space-between'}>
          {data.map((item) => {
            const { name } = item;
            return (
              <Col span={12} key={name}>
                <Form.Item
                  label={item.label}
                  name={item.name}
                  rules={
                    item.rules ? item.rules : [{ required: item.required }]
                  }
                >
                  {rendercomponents({
                    ...obj,
                    data: item,
                    dicList
                  })}
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      </Form>
    );
  };

  const onModalCancel = () => {
    setOpen(false);
    form.resetFields();
    handleCancel?.();
  };

  return (
    <ZeissModal
      open={open}
      width={750}
      centered
      footer={null}
      onCancel={onModalCancel}
      destroyOnClose
      className="pc-baseinfo-Modal"
    >
      <div className="pc_baseinfo_layout">
        <div className="pc-createAnnouncement-title">修改公告信息</div>
        <div>{renderForm(NOTICE_FORM_LIST, form)}</div>

        <Space className="pc-createAnn-footer" size="middle">
          <ZeissButton className="pc-createAnn-cancel" onClick={onModalCancel}>
            取消
          </ZeissButton>
          <ZeissButton
            type="primary"
            className="pc-createAnn-sales"
            onClick={createProjectHandle}
          >
            确认修改
          </ZeissButton>
        </Space>
      </div>
    </ZeissModal>
  );
};
